<template>
   <div class="footer">
    <div class="footer_left">
      <!-- <span> © 2020北京中科凡语科技有限公司</span>
      <span>京ICP备17005035号-6</span> -->
      <div class="footer_site">
        <span><i class="icon_email"></i>guanghua.li@anylangtech.com</span>
        <span><i class="icon_phone"></i>010-61934155</span>
        <span><i class="icon_site"></i>北京市海淀区知春路甲63号卫星大厦1006室</span>
      </div>
      <div class="footer_records">
        @2020 北京中科凡语科技有限公司（Beijing Fanyu Technology Co., Ltd）
        <br>
        京公网安备11010802030832号 京ICP备17022088号-2
      </div>
    </div>
    <div class="footer_right">
      <div class="footer_right_tit">关注飞译</div>
      <div class="footer_code">
        <div class="footer_code_item">
          <img src="../assets/imgs/home/fy_code.png" alt="飞译二维码">
          <div>飞译公众号</div>
        </div>
        <div class="footer_code_item">
          <img src="../assets/imgs/home/zkfy_code.png" alt="中科凡语二维码">
          <div>中科凡语公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {

    };
  },
};
</script>

<style lang="less" scoped>
.footer {
  height: 248px;
  width: 100%;
  text-align: center;
  background: #1e252f;
  display: flex;
  justify-content: center;
  align-items: center;
  .footer_left {
    width: 42%;
    min-width: 610px;
    margin-right: 114px;
    .footer_site {
      font-size: 12px;
      font-weight: normal;
      color: #ffffff;
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #393d40;
      padding: 0px 5px 10px;
      margin-bottom: 20px;
      .icon_email {
        display: inline-block;
        width: 16px;
        height: 11px;
        background: url("../assets/imgs/home/youxiang-icon.png") center
          no-repeat;
        background-size: contain;
        position: relative;
        top: 2px;
        margin-right: 5px;
      }
      .icon_phone {
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url("../assets/imgs/home/lianxifangshi-icon.png") center
          no-repeat;
        background-size: contain;
        position: relative;
        top: 2px;
        margin-right: 5px;
      }
      .icon_site {
        display: inline-block;
        width: 11px;
        height: 17px;
        background: url("../assets/imgs/home/dizhi -icon.png") center
          no-repeat;
        background-size: contain;
        position: relative;
        top: 2px;
        margin-right: 5px;
      }
    }
    .footer_records {
      font-size: 14px;
      color: #64686e;
    }
  }
  .footer_right {
    .footer_right_tit {
      text-align: left;
      font-size: 18px;
      
      color: #ffffff;
    }
    .footer_code {
      img {
        width: 129px;
        height: 127px;
        border: 1px solid #fff;
      }
      .footer_code_item {
        float: left;
        margin-top: 14px;
        margin-right: 14px;
        font-size: 14px;
        
        color: #80848a;
      }
    }
  }
}
</style>
